import React, { useEffect, useState } from 'react';
import {
  Box, CircularProgress, Typography, Button, Paper
} from '@mui/material';

/**
 * ConnectingScreen — displayed to the user while waiting for astrologer to accept.
 *
 * Props:
 *   astrologerName: string
 *   type: 'chat'|'call'|'video'
 *   onTimeout: () => void
 *   onCancel: () => void
 *   timeoutMs: number (default 30000)
 */
const ConnectingScreen = ({
  astrologerName,
  type = 'chat',
  onTimeout,
  onCancel,
  timeoutMs = 30000,
}) => {
  const [secondsLeft, setSecondsLeft] = useState(Math.floor(timeoutMs / 1000));

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          onTimeout && onTimeout();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [onTimeout]);

  const typeLabels = { chat: 'Chat', call: 'Voice Call', video: 'Video Call' };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
    >
      <Paper elevation={3} sx={{ p: 5, textAlign: 'center', maxWidth: 360 }}>
        <CircularProgress size={60} thickness={4} sx={{ mb: 3 }} />
        <Typography variant="h6" gutterBottom>
          Connecting to {astrologerName}…
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Waiting for astrologer to accept your {typeLabels[type] || type} request
        </Typography>
        <Typography variant="caption" color="warning.main" display="block" mb={3}>
          Auto-cancel in {secondsLeft}s if no response
        </Typography>
        <Button variant="outlined" color="error" onClick={onCancel}>
          Cancel
        </Button>
      </Paper>
    </Box>
  );
};

export default ConnectingScreen;
